import React from "react";
import PropTypes from "prop-types";
import HeaderFunctions from "../common/HeaderFunctions";
import HeaderFunctionItem from "../common/HeaderFunctionItem";

const HeaderRightFunction = ({ items }) => {
	return (
		<nav>
			<HeaderFunctions>
				{items.map((item, i) =>
					<HeaderFunctionItem
						key={i}
						display={item.text}
						iconType={item.iconType}
						color={item.color}
						to={item.to}
						disabled={item.disabled}
						visible={item.visible}
						customNavAction={item.customNavAction} />
				)}
			</HeaderFunctions>
		</nav>
	);
};

HeaderRightFunction.propTypes = {
	items: PropTypes.array.isRequired
};

export default HeaderRightFunction;